import createDataContext from './createDataContext';
import * as actions from './actions/serviceRecordActions';
import { reducer, initialState } from './reducers/serviceRecordReducer';

export const { Context: ServiceRecordContext, Provider } = createDataContext(
  reducer,
  actions,
  initialState
);
